import { Dispatch } from 'react';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import {
  addQueuePackageServiceCount,
  resetQueuePackageServiceCount,
} from '../../../store/emarsys/action';

export default function eventClickPackageService(
  dispatch: Dispatch<any>,
  selectedPackage: any,
  selectedCar: any,
  pageTitle: string = '',
  breadcrumbItems: IBreadcrumbs[],
  customerNo: string,
  sectionName: string,
  buttonName: string,
  newParams?: Record<string, string | number | boolean>
) {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isPackageServiceDetailActive = getFlagValue(FLAG_ENUM.EMARSYS_PACKAGE_SERVICE_DETAIL);
  if (!isFlagActive || !isPackageServiceDetailActive) return;
  if (customerNo) {
    ScarabQueue.push(['setCustomerId', customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: 'paket servis detail page',
    page_title: pageTitle,
    page_url: window.location.href,
    menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toUpperCase() || '',
    menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase() || '',
    menu_cat_lvl3: breadcrumbItems?.[3]?.name?.toUpperCase() || '',
    menu_cat_lvl4: breadcrumbItems?.[4]?.name?.toUpperCase() || '',
    package_name: selectedPackage?.typeOfService?.toLowerCase() || '',
    sku_price: (
      selectedPackage?.strikeThroughPrice?.value ||
      selectedPackage?.price?.value ||
      0
    ).toString(),
    car_category: selectedPackage?.bodyTypeName || '',
    car_model: selectedPackage?.carModelService || '',
    car_type: selectedCar?.vehicleName || '',
    section_name: sectionName,
    button_name: buttonName,
    ...newParams,
  };

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);
  if (buttonName.includes('lihat semua')) {
    ScarabQueue.push(['go']);
    dispatch(resetQueuePackageServiceCount());
  } else {
    dispatch(addQueuePackageServiceCount());
  }
}
